import { createContext } from "react";

const ticketContext = createContext();

export default ticketContext;